// The "take the sensor to its spot" interstitial that opens the connected
// flow. It used to live inside the wifi-select step, which put it after probe
// setup and naming; it now leads so the user is standing at the install
// location for everything that depends on it — the pipe-placement question,
// plugging in the probe, naming, and the wifi coverage check.
export class StepConnectedLocation {
  constructor (onboarding) {
    this.onboarding = onboarding;
  }

  id = "connected_location";
  title = "Sensor Placement";

  help_open = false;

  template = `
  <div class="onboarding-step" data-for="connected_location">

    <div class="onboarding-wifi-location-intro" data-for="location-intro">
      <div class="onboarding-instruction__hero-placeholder">
        <img data-for="location-hero" src="" alt="" />
      </div>
      <h2 class="onboarding-guide-heading">Take the Temp Stick to its spot</h2>
      <p class="onboarding-guide-instruction">
        Bring your Temp Stick to its installation location so we can confirm Wi-Fi coverage before mounting.
      </p>
      <div class="onboarding-instruction__actions">
        <button type="button" class="button onboarding-guide-next-btn" data-for="location_continue">
          I'm at the spot, continue
        </button>
        <button type="button" class="onboarding-guide-help-btn onboarding-instruction__help-link" data-for="location_open_help">
          Device placement guide
        </button>
      </div>
    </div>

    <div class="onboarding-wifi-location-help" data-for="location-help">
      <h2 class="onboarding-guide-heading">Device placement guide</h2>
      <p class="onboarding-guide-instruction">
        Temp Stick uses 2.4&nbsp;GHz wifi. A few rules of thumb will save you trouble later.
      </p>
      <div class="onboarding-selective-questions-help">
        <div class="onboarding-selective-questions-help__item">
          <div class="onboarding-selective-questions-help__heading">Mind the distance</div>
          <div class="onboarding-selective-questions-help__text">Most home routers reach roughly 50&ndash;100&nbsp;feet indoors. Every wall, floor, or appliance in between weakens the signal &mdash; concrete, brick, and tile are the worst offenders.</div>
        </div>
        <div class="onboarding-selective-questions-help__item">
          <div class="onboarding-selective-questions-help__heading">Steer clear of large metal</div>
          <div class="onboarding-selective-questions-help__text">Refrigerators, safes, filing cabinets, and metal ductwork can block wifi almost entirely. Don't tuck the sensor behind or inside them.</div>
        </div>
        <div class="onboarding-selective-questions-help__item">
          <div class="onboarding-selective-questions-help__heading">Avoid sealed metal enclosures</div>
          <div class="onboarding-selective-questions-help__text">If you need to monitor the inside of a metal-walled freezer, fridge, or cabinet, mount the sensor outside and run a probe in instead.</div>
        </div>
        <div class="onboarding-selective-questions-help__item">
          <div class="onboarding-selective-questions-help__heading">Watch for interference</div>
          <div class="onboarding-selective-questions-help__text">Microwaves, cordless phones, baby monitors, and some Bluetooth devices share the 2.4&nbsp;GHz band and can cause drop-outs when active nearby.</div>
        </div>
        <div class="onboarding-selective-questions-help__item">
          <div class="onboarding-selective-questions-help__heading">Mount higher when you can</div>
          <div class="onboarding-selective-questions-help__text">Chest height or above generally gets a stronger, more consistent signal than floor or basement placement.</div>
        </div>
        <div class="onboarding-selective-questions-help__item">
          <div class="onboarding-selective-questions-help__heading">Test before you commit</div>
          <div class="onboarding-selective-questions-help__text">Stand at the intended spot and check your phone's wifi signal on the same network. If you see fewer than two bars, expect the sensor to struggle &mdash; pick a closer location or consider a wifi extender.</div>
        </div>
      </div>
      <div class="onboarding-instruction__actions">
        <button type="button" class="button onboarding-guide-next-btn" data-for="location_close_help">
          Got it
        </button>
      </div>
    </div>

  </div>
  `;

  onBack = () => {

    // The placement guide backs out to the intro. The intro itself is the first
    // connected step — there's nothing behind it, so the button is hidden.
    if (this.help_open) {
      this.showIntro();
    }

  }

  onActivate = () => {

    // Pick the hero for the sensor being set up.
    const heroBase = this.onboarding.isSelective() ? 'setup-hero-selective-location' : 'setup-hero-location';
    this.$hero.attr('src', `${window.site.home}/../assets/images/${heroBase}.png`);

    this.showIntro();

  }

  showIntro = () => {
    this.help_open = false;
    this.$intro.show();
    this.$help.hide();
    this.onboarding.hideBackButton();
  }

  showHelp = () => {
    this.help_open = true;
    this.$intro.hide();
    this.$help.show();
    this.onboarding.showBackButton();
  }

  bindActions = () => {

    const $step = $(this.onboarding.container).find('.onboarding-step[data-for="connected_location"]');

    this.$intro = $step.find('[data-for="location-intro"]');
    this.$help = $step.find('[data-for="location-help"]');
    this.$hero = this.$intro.find('img[data-for="location-hero"]');

    $step.find('button[data-for="location_continue"]').on('click', () => {
      this.onboarding.goToStepAfterLocation();
    });

    $step.find('button[data-for="location_open_help"]').on('click', () => {
      this.showHelp();
    });

    $step.find('button[data-for="location_close_help"]').on('click', () => {
      this.showIntro();
    });

  }

}
